import { useParams } from 'react-router'
import { useQuerySources } from '@hooks/useQuery'
import AvatarPlaceholder from '@components/AvatarPlaceholder/AvatarPlaceholder'
import BackButton from '@components/BackButton/BackButton'

import './BuilderHeader.css'

export default function BuilderHeaderView() {
  const { id } = useParams<{ id: string }>()
  const { query } = useQuerySources(id as string)

  const ownerName = query.owner.name || 'User'
  const title = query.title ?? ''

  return (
    <>
      <div>
        <BackButton />
      </div>
      <div className="query-data">
        <div className="user-data">
          <AvatarPlaceholder text={ownerName} />
          <span className="user-name">{ownerName}</span>
        </div>
        <div>{'/'}</div>
        <h1 title={title} className="editable-title">
          <span>{title}</span>
        </h1>
      </div>
    </>
  )
}
